import SelectFilter from "@components/common/SelectFilter.jsx";
import useFilterData from "@hooks/useFilterData.js";

function ClientsFilter({
	value,
	onChange,
	businessUnitId = null,
	distributorId = null,
	params = {},
	enabled = true,
	hideLabel = false,
}) {
	const { data, isLoading, hasMore, searchTerm, loadMore, setSearchTerm } = useFilterData({
		endpoint: "/api/clients",
		pageSize: 10,
		enabled,
		queryParams: {
			distributor_id: distributorId,
			businessUnit: businessUnitId,
			...params,
		},
	});

	return (
		<SelectFilter
			id="client-filter"
			dataTestId="client-filter"
			label={!hideLabel && "Filter by"}
			placeholder="Client"
			value={value}
			onChange={onChange}
			options={data}
			isLoading={isLoading}
			hasMore={hasMore}
			onLoadMore={loadMore}
			searchTerm={searchTerm}
			onSearchChange={setSearchTerm}
			optionLabel="name"
			optionValue="id"
			showSearch={true}
			searchPlaceholder="Search by client"
		/>
	);
}
export default ClientsFilter;
